import { AdPreviewDialog } from "@/app/Promotions/Components/AdPreviewDialog";
import { PromotionCreative } from "@/app/Promotions/GraphQL/promotionCreativeQuery";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { useTranslations } from "use-intl";

/**
 * The creative is snapshotted onto the promotion when the ad is created, so
 * this previews what is actually running rather than what the relocation would
 * produce today.
 */
export function AdPreviewCell({
  creative,
}: {
  creative: PromotionCreative | null | undefined;
}) {
  const { open: openPreviewDialog } = useDialog(AdPreviewDialog);
  const t = useTranslations("promotion.table");

  return (
    <button
      type="button"
      aria-label={t("ad")}
      className="block"
      onClick={() => {
        openPreviewDialog({ creative: creative ?? null });
      }}
    >
      {creative?.image_url ? (
        <img
          src={creative.image_url}
          alt={creative.title}
          className="aspect-square size-12 shrink-0 rounded-md object-cover"
        />
      ) : (
        <div className="aspect-square size-12 shrink-0 rounded-md bg-gray-100" />
      )}
    </button>
  );
}
